import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgZap = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 12,
	viewBox: "0 0 10 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.69909 0.541347C5.9027 0.629731 6.02366 0.841765 5.99613 1.06201L5.56638 4.5L8.66387 4.5C8.78437 4.49997 8.90642 4.49995 9.00613 4.50898C9.10044 4.51752 9.28102 4.5401 9.43763 4.66666C9.61691 4.81154 9.71962 5.03082 9.71615 5.26131C9.71311 5.46263 9.61486 5.61582 9.56104 5.69373C9.50415 5.77611 9.426 5.86985 9.34885 5.9624L4.8841 11.3201C4.74201 11.4906 4.5045 11.547 4.3009 11.4586C4.09729 11.3703 3.97632 11.1582 4.00385 10.938L4.4336 7.5L1.33611 7.5C1.21561 7.50002 1.09356 7.50004 0.99385 7.49102C0.899546 7.48248 0.718963 7.45989 0.562356 7.33334C0.383068 7.18845 0.280362 6.96917 0.283838 6.73869C0.286874 6.53736 0.385128 6.38418 0.438941 6.30626C0.495843 6.22388 0.573997 6.13013 0.651157 6.03757C0.654978 6.03299 0.658796 6.02841 0.662609 6.02383L5.11588 0.679905C5.25798 0.509388 5.49548 0.452962 5.69909 0.541347ZM1.56751 6.5H4.99999C5.14341 6.5 5.27992 6.56158 5.37483 6.6691C5.46974 6.77661 5.51392 6.91971 5.49613 7.06202L5.20766 9.36977L8.43247 5.5H4.99999C4.85658 5.5 4.72007 5.43841 4.62515 5.3309C4.53024 5.22338 4.48606 5.08029 4.50385 4.93798L4.79232 2.63023L1.56751 6.5Z",
		fill: "currentColor"
	})
});
export default SvgZap;
